import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import classnames from 'classnames';
import SimpleThread from '../SimpleThread';
import s from './CardLayoutThread.scss';
const CardLayoutThread = (props)=>{
    return /*#__PURE__*/ React.createElement(SimpleThread, _object_spread_props(_object_spread({}, props), {
        className: classnames(s['card-layout'], props.className),
        commentBoxWrapperClassName: s['commentbox-wrapper'],
        threadStackClassName: s['thread-stack'],
        headerClassName: s['header'],
        scrollableClassName: s['scrollable'],
        replyIndentModifier: 0
    }));
};
CardLayoutThread.displayName = 'CardLayoutThread';
export default CardLayoutThread;

//# sourceMappingURL=CardLayoutThread.js.map